import React from 'react';
import { formatButtonValue } from '../KPIComponent/formatUtils';
import { ACTOR_CATEGORIES } from '../../constants';

const InteractionButtons = ({ 
  categories, 
  selectedCategories, 
  onCategoryToggle, 
  categoryColorMap,
  mode // Add mode prop
}) => {
  // Sort categories to match the order in ACTOR_CATEGORIES
  const sortedCategories = [...categories].sort((a, b) => {
    const aIndex = ACTOR_CATEGORIES.findIndex(cat => cat.name === a.name);
    const bIndex = ACTOR_CATEGORIES.findIndex(cat => cat.name === b.name);
    return aIndex - bIndex;
  });
  
  return (
    <div className="button-container">
      {sortedCategories.map(category => (
        <button
          key={category.name}
          className={`btn-common ${selectedCategories.includes(category.name) ? 'active' : ''}`}
          onClick={() => onCategoryToggle(category.name)}
          style={{
            padding: '4px 10px',
            fontSize: 'var(--font-size-md)',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px'
          }}
        >
          <span 
            className="event-color-dot" 
            style={{ 
              backgroundColor: categoryColorMap[category.name],
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              display: 'inline-block'
            }}
          />
          <span className="event-type-label">{category.name}</span>
          <span className="event-count">
            {formatButtonValue(
              mode === 'events' ? category.count : (category.fatalities || 0),
              (mode === 'events' ? category.count : category.fatalities) >= 1000 ? 'thousands' : 'number'
            )}
          </span>
        </button>
      ))}
    </div>
  );
};

export default InteractionButtons;
